module.exports = __webpack_public_path__ + "static/img/rollupimg.7ebd9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/article/rollupimg.jpg
// module id = jjGj
// module chunks = 0